export const DOT_WIDTH = 12;
export const MAX_DOTS_COUNT = 7;
export const MAX_DOTS_HALF_COUNT = Math.floor(MAX_DOTS_COUNT / 2);
